<template>
	<section v-if="options.customId">
		<hr>
		<vue-poll v-bind="options" @addvote="addVote"/>
	</section>
</template>

<script lang="js">

	import VuePoll 		from "vue-poll";
	import axios 		from "axios";
	import api 			from "../libs/api";

	export default {
		name: "poll",
		data() {
			return {
				id: this.$props.scopeId,
				type: this.$props.scopeType,
				options: {
					question: null,
					answers: [],
					showResults: true,
					finalResults: false,
					multiple: false,
					customId: 0
				},
				item: {
					value: 0,
					text: null,
					votes: 0,
					selected: false
				}
			}
		},
		components: {
			VuePoll
		},
		props: {
			scopeId: {
				type: Number
			},
			scopeType: {
				type: String
			}
		},
		created() {
			this.getPoll();
		},
		methods: {
			addVote(obj) {
				axios.post(api.message.setPoll, {id: obj.customId, value: obj.value}).catch((error) => {
					this.$bvToast.toast(`${error.response.data.code}: ${error.response.data.message}`, {
						title: this.$t('error.ln_5'),
						autoHideDelay: 5000,
						toaster: 'b-toaster-bottom-right',
						variant: 'danger',
					});
				});
			},
			getPoll() {
				axios.post(api.message.getPoll, {id: this.$data.id}).then((response) => {

					this.$data.options.answers = [];

					if (response.data.source !== undefined) {

						this.$data.options.customId = Number(response.data.id);
						this.$data.options.question = response.data.name;
						this.$data.options.showResults = response.data.vote;
						this.$data.options.finalResults = response.data.final !== undefined;

						for (let i = 0; i < response.data.source.length; i++) {

							this.$data.item.value = i;
							this.$data.item.text = response.data.source[i].text;
							this.$data.item.votes = response.data.source[i].votes === undefined ? 0 : Number(response.data.source[i].votes);
							this.$data.item.selected = response.data.source[i].selected !== undefined;

							this.$data.options.answers.push(Object.assign({}, this.$data.item));
						}

					}

				});
			}
		}
	}
</script>

<style>

	.vue-poll .qst {
		font-size: 18px;
	}

	.vue-poll .ans-cnt .ans .bg {
		border-radius: 5px !important;
	}

</style>